module.exports = __webpack_public_path__ + "img/products.81606aae.svg";